import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextTransition from 'react-text-transition';

const TextTransitionInterval = props => {
  const { texts } = props;
  const [activeText, setActiveText] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveText(prev => prev + 1);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return <TextTransition text={texts[activeText % texts.length]} />;
};

TextTransitionInterval.propTypes = {
  texts: PropTypes.arrayOf(PropTypes.string).isRequired,
  interval: PropTypes.number,
};

TextTransitionInterval.defaultProps = {
  interval: 4000,
};

export default TextTransitionInterval;
